module.exports = __webpack_public_path__ + "img/camera.3c90033c.svg";